<div class="svg-icon">
    <div class="icon" [ngStyle]="{'width': width, 'height': height, 'background-image': 'url(assets/icons/' + src + ')'}"></div>
</div>